import { Resources } from 'constants/resources';

import EventNoteIcon from '@mui/icons-material/EventNote';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { useRecordContext } from 'react-admin';
import { Link } from 'react-router-dom';
import { IconButton } from 'shared/mui/IconButtons';

type Props = {
  entityName: string;
  entityId?: string;
  target?: string;
};

export const UserActionsIconButton: React.FC<Props> = ({
  entityName,
  entityId,
  target = '_blank',
}) => {
  const { createPathWithQuery } = useCreatePathWithQuery();
  const record = useRecordContext();

  const to = createPathWithQuery(
    {
      resource: Resources.UserActions,
      type: 'list',
    },
    {
      filter: { entityId: entityId || record?.originId, entityName: [entityName] },
    },
  );

  return (
    <IconButton component={Link} target={target} to={to}>
      <EventNoteIcon style={{ fontSize: 'inherit', marginTop: '1px' }} />
    </IconButton>
  );
};
